import { render, staticRenderFns } from "./FAQWalkFAQ.vue?vue&type=template&id=28a5e79a&scoped=true"
import script from "./FAQWalkFAQ.vue?vue&type=script&lang=js"
export * from "./FAQWalkFAQ.vue?vue&type=script&lang=js"
import style0 from "./FAQWalkFAQ.vue?vue&type=style&index=0&id=28a5e79a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a5e79a",
  null
  
)

export default component.exports